import { fromCamelCase } from 'utils/format';

export function inputValueFormatter(value: string, field: string) {
  if (field === 'actionReview') {
    const result = fromCamelCase(value);
    return result.replace('Alix Partners', 'AlixPartners');
  }
  return value;
}
